/**
 * Shared date formatting for the overview / list pages.
 *
 * Both helpers return an em dash for an empty value. formatDateTime returns
 * the em dash for an unparsable value as well, formatDateOnly hands the raw
 * value back so an unexpected server string is still visible.
 */

/** Local date and time, e.g. "9/8/2026, 2:03:45 PM". */
export const formatDateTime = (iso) => {
    if (!iso) return "—";
    const date = new Date(iso);
    return Number.isNaN(date.getTime()) ? "—" : date.toLocaleString();
};

/** Local calendar date only, e.g. "Sep 8, 2026". */
export const formatDateOnly = (value) => {
    if (!value) return "—";
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return value;
    return parsed.toLocaleDateString(undefined, {
        year: "numeric", month: "short", day: "numeric",
    });
};
